import React, { useState } from 'react';
import { Target, Plus } from 'lucide-react';
import CardBasic from '../ui/Card.jsx';
import LeadsTabs from './LeadsTabs.jsx';
import CreateLeadModal from './CreateLeadModal.jsx';

const LeadsIndex = () => {
    const [activeTab, setActiveTab] = useState('current');
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    // Always navigate to the PHP route - feature flag determines PHP vs React rendering there
    const handleEditLead = (uuid) => {
        window.location.href = `index.php/leads/detail/${uuid}`;
    };

    const handleLeadCreated = (uuid) => {
        setRefreshTrigger(prev => prev + 1);
        // Navigate to detail page after creation
        if (uuid) {
            handleEditLead(uuid);
        }
    };

    const renderHeaderActions = (tabId) => {
        // Currently no specific header actions per tab
        // Can be extended later if needed
        return null;
    };

    return (
        <div>
            <div className="mb-4">
                <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between gap-3">
                    <div>
                        <h1 className="h2 fw-bold text-dark d-flex align-items-center gap-2 mb-2">
                            <Target size={32} className="icon-leads" />
                            Anfragen
                        </h1>
                        <p className="text-muted mb-0">
                            Verwalten Sie Ihre Kundenanfragen und Leads
                        </p>
                    </div>
                    <button
                        onClick={() => setShowCreateModal(true)}
                        className="btn btn-outline-primary d-flex align-items-center gap-2 shadow"
                        style={{ border: '1px solid var(--accent-slate, #5b7c8d)', color: 'var(--accent-slate, #5b7c8d)' }}
                    >
                        <Plus size={20} />
                        Neue Anfrage
                    </button>
                </div>
            </div>
            <CardBasic>
                <LeadsTabs
                    onTabChange={handleTabChange}
                    headerActions={renderHeaderActions}
                    onEditLead={handleEditLead}
                    refreshTrigger={refreshTrigger}
                />
            </CardBasic>

            {/* Create Lead Modal */}
            <CreateLeadModal
                isOpen={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                onCreated={handleLeadCreated}
            />
        </div>
    );
}

export default LeadsIndex;
